import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const CartContext = createContext();
const GST_RATE = 0.18;
const FREE_SHIP_MIN = 499;
const SHIP_CHARGE = 60;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => { try { return JSON.parse(localStorage.getItem('rpb_cart')) || []; } catch { return []; } });

  useEffect(() => { localStorage.setItem('rpb_cart', JSON.stringify(items)); }, [items]);

  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const gstAmount = Math.round(subtotal * GST_RATE);
  const shippingCharge = subtotal >= FREE_SHIP_MIN ? 0 : (items.length ? SHIP_CHARGE : 0);
  const getTotal = (discount = 0) => subtotal + gstAmount + shippingCharge - discount;

  const addToCart = (product, qty = 1, variant = null) => {
    setItems(prev => {
      const key = product._id + (variant || '');
      const existing = prev.find(i => i._id + (i.selectedVariant || '') === key);
      if (existing) {
        toast.info('🛒 Cart updated');
        return prev.map(i => i._id + (i.selectedVariant || '') === key ? { ...i, qty: i.qty + qty } : i);
      }
      toast.success(`✅ ${product.nameHi} कार्ट में जोड़ा`);
      return [...prev, { _id: product._id, nameHi: product.nameHi, nameEn: product.nameEn, price: product.effectivePrice || product.price, image: product.images?.[0]?.url, selectedVariant: variant, qty }];
    });
  };

  const updateQty = (id, qty, variant) => {
    if (qty <= 0) { removeFromCart(id, variant); return; }
    setItems(prev => prev.map(i => i._id === id && (i.selectedVariant || null) === (variant || null) ? { ...i, qty } : i));
  };

  const removeFromCart = (id, variant) => {
    setItems(prev => prev.filter(i => !(i._id === id && (i.selectedVariant || null) === (variant || null))));
    toast.info('Removed from cart');
  };

  const clearCart = () => setItems([]);
  const cartCount = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, subtotal, gstAmount, shippingCharge, getTotal, cartCount, addToCart, updateQty, removeFromCart, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
